import { serve } from 'inngest/next'
import { inngest } from '@/lib/inngest'
import { completenessAssessmentFn } from '@/inngest/completeness-agent'
import { summarizationFn } from '@/inngest/summarization-agent'
import { sentimentAssessmentFn } from '@/inngest/sentiment-agent'
import { taggingAgentFn } from '@/inngest/tagging-agent'
import { knowledgeIndexerFn } from '@/inngest/knowledge-indexer'
import { responseDraftFn } from '@/inngest/response-draft-agent'
import { kbUpdateProposalFn } from '@/inngest/kb-update-proposal-agent'
import { expertDigestFn } from '@/inngest/expert-digest'

export const { GET, POST, PUT } = serve({
  client: inngest,
  functions: [
    completenessAssessmentFn,
    summarizationFn,
    sentimentAssessmentFn,
    taggingAgentFn,
    knowledgeIndexerFn,
    responseDraftFn,
    kbUpdateProposalFn,
    expertDigestFn,
  ],
})
